import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import ReactDOM from 'react-dom'
import { Text, Box, getPaletteColor } from 'pcln-design-system'

const AffirmTextContainer = styled(Text)`
  text-align: center;
  font-size: 12px;
  font-weight: 100;
  -webkit-font-smoothing: antialiased;
  color: ${getPaletteColor('text.light')};
  a {
    color: ${getPaletteColor('primary.base')};
    display: block;
    text-decoration: none;
  }
  a:hover {
    color: ${getPaletteColor('primary.dark')};
    text-decoration: underline;
  }
`

export default class AffirmText extends React.PureComponent {
  constructor(props) {
    super(props)
    this.affirmRef = React.createRef()
  }

  componentDidMount() {
    this.setupAffirm()
  }

  componentDidUpdate() {
    this.setupAffirm()
  }

  setupAffirm = () => {
    if (typeof window !== 'undefined' && get(window, 'affirm.widgets.as_low_as.setupElement')) {
      window.affirm.widgets.as_low_as.setupElement(
        // eslint-disable-next-line react/no-find-dom-node
        ReactDOM.findDOMNode(this.affirmRef.current)
      )
    }
  }

  /* This is to prevent double click event on itinerary slices */
  stopEventPropogation = (e) => {
    e.stopPropagation()
  }

  render() {
    const { dataAmount } = this.props

    return (
      <Box>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <span onClick={this.stopEventPropogation}>
          <AffirmTextContainer
            data-testid={'affirm-text-container'}
            ref={this.affirmRef}
            className='affirm-as-low-as'
            data-page-type='search'
            data-amount={dataAmount}
            bold
          />
        </span>
      </Box>
    )
  }
}

AffirmText.propTypes = {
  dataAmount: PropTypes.number,
}
